import { labelHeaderSuggestionsPassword } from "../../_constants";

export const HeaderSuggestionsPassword = () => {
  return (
    <p className="text-base-regular margin-bottom-14 font-weight-600">
      {labelHeaderSuggestionsPassword}
    </p>
  );
};
